import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Customer } from 'app/_models/customer';
import { Dealer } from 'app/_models/dealer';
import { CustomersService } from 'app/_services/customers.service';
import { DealersService } from 'app/_services/dealers.service';

@Component({
  selector: 'app-carworkshopdnc',
  templateUrl: './carworkshopdnc.component.html',
  styleUrls: ['./carworkshopdnc.component.css'],
  providers: [ CustomersService, DealersService ]
})
export class CarworkshopdncComponent implements OnInit {

  private dealer: Dealer;
  private customer: Customer;
  private regNrResolved: boolean = false;

  private customerDealerId: string;
  private customerMauticId: string;
  private customerRegNumber: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private dealerService: DealersService,
    private customerService: CustomersService) { }

  ngOnInit() {
    // Get the customer data from the query params
    this.activatedRoute.queryParams.subscribe((params) => {
      this.customerDealerId = params["dealer"];
      this.customerMauticId = params["customer"];
      this.customerRegNumber = params["regnr"];

      //Now, validate that all query parameters is present
      this.validateQueryParams();
    });
  }

  validateQueryParams() {
    // If the query parameters wasn't provided, redirect the user to the dealers external site.
    if (!this.customerDealerId || !this.customerMauticId || !this.customerRegNumber) {
      window.location.href = this.getErrorRedirectUrl();
    }
    else {
      this.getDealerInfo();
    }
  }

  getDealerInfo() : void {
    this.dealerService.read(this.customerDealerId)
      .subscribe(
        (dealer) => {
          this.dealer = dealer;
          this.getCustomerInfo();
        },
        (error) => {
          window.location.href = this.getErrorRedirectUrl();
        }
      );
  }

  getCustomerInfo() : void {
    this.customerService.getCustomerByMauticIdAndRegistration(
      this.customerMauticId, 
      this.customerRegNumber, 
      this.customerDealerId)
      .subscribe(
        (customer) => {
          this.regNrResolved = true;
          this.customer = customer;
          this.sendCarworkshopDnc();
        },
        (error) => {
          window.location.href = this.getErrorRedirectUrl();
        } 
      );
  }
  
  sendCarworkshopDnc() {
    this.customer.carWorkshopDnc = true;
    this.customerService.setCarWorkshopDNC(this.customer, true)
      .subscribe(
        () => {

        },
        (error) => {

        }
      );
  }

  getErrorRedirectUrl(): string {
    if (this.customerDealerId) {
      switch (this.customerDealerId) {
        case "5ec7b995f99d985b5e8f02ab": // Nellemann
          return "https://nellemann.dk";
        case "5a217c8c865e0807cb47fa9c": // Elmer
          return "https://bilhusetelmer.dk";
      }
    }
    else {
      return "https://forhandlerportal.micar.dk"
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/landingpages/carworkshopdnc/carworkshopdnc.component.ts